module.exports = __webpack_public_path__ + "img/gallery13.86b15332.png";